<template>
  <div>
    <b-menu v-if="forums">
      <div class="custom-panel custom-panel-grey mb-5">
        <b-button
          @click="showTopicForm"
          label="Start a Discussion"
          size="is-small"
          type="is-primary"
          icon-left="comment"
          expanded />

        <b-button
          @click="showTopicForm('bugs')"
          label="Send us a Bug"
          size="is-small"
          type="is-danger"
          icon-left="bug"
          expanded
          class="mt-2" />

        <div v-if="isAuthenticated && selectedForum" class="mt-4" style="font-size: 12px;">
          Subscribe to {{ selectedForum.title }}:
          <a @click="subscribeMail">
            <b-icon
              icon="envelope"
              size="is-small" />
          </a>
          <a :href="`https://api.oddgiants.com/public/forums/${selectedForum.slug}/feed`" target="_blank">
            <b-icon
              style="color: #EE802F;"
              icon="rss"
              size="is-small" />
          </a>
        </div>
      </div>

      <form @submit="handleSearch" class="mb-5">
        <b-field custom-class="w-100" expanded>
          <b-input placeholder="Search forums..." type="search" v-model="keyword" expanded></b-input>
          <p class="control">
            <b-button type="is-primary" native-type="submit" icon-right="search" />
          </p>
        </b-field>
      </form>

      <b-menu-list class="mt-6">
        <b-menu-item
          style="font-size: 14px;"
          v-for="forum in forums"
          :key="forum.id"
          tag="router-link"
          :to="`/forums/${forum.slug}`"
          :label="`${forum.title} (${forum.topics_count})`"
          :active="isForumSelected(forum.slug)"
        ></b-menu-item>
      </b-menu-list>
    </b-menu>

    <b-loading :is-full-page="false" v-model="loadingForums"></b-loading>
    <b-loading :is-full-page="true" v-model="loadingSubscribe"></b-loading>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { Forum } from '@/services/api';

export default {
  name: 'navigation',
  computed: {
    ...mapGetters('user', ['isAuthenticated']),
    ...mapGetters('forum', ['isBugsSelected', 'isAnnouncements']),
    ...mapState('forum', ['loadingForums', 'forums', 'selectedForum']),
  },
  data() {
    return {
      loadingSubscribe: false,
      keyword: '',
    };
  },
  mounted() {
    this.$store.dispatch('forum/loadForums');
  },
  methods: {
    isForumSelected(forumSlug) {
      return this.selectedForum && forumSlug === this.selectedForum.slug;
    },
    handleSearch(event) {
      event.preventDefault();

      this.keyword = this.keyword.trim();

      if (this.keyword.length < 3) {
        this.errors = ['Please enter something longer to search for'];

        return;
      }

      this.$router.push({ path: `/forums/search/${this.keyword.trim()}` });
    },
    showTopicForm(forum) {
      if (this.isAuthenticated) {
        let forumSlug = this.selectedForum && this.selectedForum.slug !== 'announcements'
          ? this.selectedForum.slug
          : null;

        if (forum === 'bugs') {
          forumSlug = 'bugs';
        }

        this.$store.dispatch('forum/setTopicFormForum', forumSlug);
        this.$store.dispatch('global/toggleForumTopicModal', true);
      } else {
        this.$store.dispatch('global/toggleLoginModal', true);
      }
    },
    subscribeMail() {
      this.$buefy.dialog.confirm({
        title: 'Subscribe?',
        message: `You will receive emails for every new topic, added to the ${this.selectedForum.title} forum. You can always unsubscribe by following the unsubscribe link in the emails.`,
        confirmText: 'Subscribe',
        type: 'is-info',
        hasIcon: true,
        onConfirm: () => {
          this.loadingSubscribe = true;

          Forum.subscribeForum(this.selectedForum.slug)
            .then(() => {
              this.$buefy.dialog.alert({
                title: 'Subscribed!',
                message: 'Thank you! You will receive email notifications when someone starts a new discussion in this forum.',
                type: 'is-success',
                hasIcon: true,
                icon: 'check',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
              });
            })
            .catch((error) => {
              const responseError = error.response.data;

              this.$buefy.dialog.alert({
                title: 'Error',
                message: responseError.message || 'Sorry, something went wrong :( Please try again later...',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
              });
            })
            .finally(() => {
              this.loadingSubscribe = false;
            });
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
